module.exports = __webpack_public_path__ + "static/media/DefaultGroup.715bf2ec.svg";